export enum EntityStatusType {
    Active = 'Active',
    Inactive = 'Inactive',
}

/**
 * Who a status rule applies to. Supervisors count as Office; the split exists in task targeting, not here.
 *
 * A status names parties rather than roles or rights: a tenant renames roles and reassigns rights, so a
 * rule pinned to a role stops meaning what it was configured to mean the first time an admin edits it.
 */
export enum Party {
    Office = 'Office',
    Field = 'Field',
    Contractor = 'Contractor',
    Customer = 'Customer',
}
